var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAllasPlusLogo = function SvgAllasPlusLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 45 45"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5265",
    fillRule: "evenodd",
    d: "M29.036 26.63V8.277h-9.41v1.59s-2.109-1.727-6.63-1.863C9.558 7.9 4.467 10.291 2.063 15.91c-1.282 2.996-2.36 7.467-.761 11.54 4.597 11.706 15.144 9.359 15.144 9.359l3.18-9.314v9.268h9.455L31.5 26.631zm-9.384-.063s-.429-.67-1.225-.542c-.895.144-1.725.52-2.986 1.111-1.011.475-2.441.898-3.81.125-1.38-.78-1.692-2.429-1.61-3.273.07-.715.507-1.597 1.634-2.015 1.04-.386 1.718-.306 1.718-.306s-1.458-2.43.41-3.854 4.488-.127 5.284 2.018c1.137 3.068.585 6.736.585 6.736",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5265",
    d: "M36.75 23.95H31.5v-2.7h5.25V16h2.7v5.25h5.25v2.7h-5.25v5.25h-2.7z"
  })));
};
export default SvgAllasPlusLogo;